export default {
  obraID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  responsavelID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  favorecidoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  secaoRH: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  secaoRHID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  equipe: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  valorSolicitado: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  },
  justificativa: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  },
  situacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  localTrabalho: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  localTrabalhoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  accept: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/term/consentterm-form.js